// Libraries
import { IconButton } from '@mui/material';

// Icon
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';

// Global
import { defaultCounty, defaultState, defaultMap} from "../utils/Global";
import { handleDrillUp } from "../utils/AnalyticsTracking";

export default function FullScreen({mapRef, geoFocus, setGeoFocus, selectedState, setSelectedState, setSelectedCounty }: 
                                   {mapRef: any, geoFocus: string, setGeoFocus: Function, selectedState:any, setSelectedState: Function, setSelectedCounty: Function}): JSX.Element {
    
    const clickFullScreen = (event: any) => {
        if (geoFocus === "State") {
            mapRef.current.setView(defaultMap.latlng, defaultMap.zoom);
            setSelectedState(defaultState);
            setSelectedCounty(defaultCounty);
            setGeoFocus('US')
        } else if (geoFocus === "County") {
            mapRef.current.setZoom(selectedState.stfp === "45"? 8: 7);
            setGeoFocus('State');
            setSelectedCounty(defaultCounty);
        }
        handleDrillUp();
    }

    return(
        <IconButton className="Control-FullScreen" onClick={clickFullScreen} disabled={geoFocus === 'US'? true: false}>
            <ZoomOutMapIcon/>
        </IconButton>
    )
}
